/** Default mic level required to show the speaking ring / detect voice. */
export const DEFAULT_INPUT_ACTIVATION_THRESHOLD = 0.08;

export const MIN_INPUT_ACTIVATION_THRESHOLD = 0.02;
export const MAX_INPUT_ACTIVATION_THRESHOLD = 0.4;

export function clampInputActivationThreshold(value: number): number {
  if (!Number.isFinite(value)) return DEFAULT_INPUT_ACTIVATION_THRESHOLD;
  return Math.min(
    MAX_INPUT_ACTIVATION_THRESHOLD,
    Math.max(MIN_INPUT_ACTIVATION_THRESHOLD, value),
  );
}

export function inputActivationThresholds(threshold: number) {
  const speakOn = clampInputActivationThreshold(threshold);
  return {
    speakOn,
    speakOff: speakOn * 0.5,
  };
}
